module.exports = __webpack_public_path__ + "static/people_pop11-1ceb1dfd03e45284d7e43f4c3c837e05.png";